import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import IconButton from 'components/common/IconButton';
import IconSave from 'components/icons/IconSave';
import IconCrossBold from 'components/icons/IconCrossBold';

import { updatePatientMessageTemplate } from 'redux/modules/patientsMessagesTemplates';

import * as validate from 'utils/validate';

const styles = () => ({
  root: {
    marginTop: -3,
  },
  iconSave: {
    width: 21,
    height: 21,
  },
  iconCrossBold: {
    width: 13,
    height: 13,
  },
  gridItemShrink: {
    flexShrink: 1,
    minWidth: 0,
  },
  iconButton: {
    marginTop: -9,
  },
});

function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(updatePatientMessageTemplate({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
  (err) => {
    if (err.error) {
      throw new SubmissionError({ _error: err.error });
    }
    throw new SubmissionError(err);
  });
}

const NotificationsDialogTemplatesItemEditForm = ({
  handleSubmit,
  submit,
  className,
  onCancel,
  onClick,
  initialValues,
  classes,
}) => (
  <form
    onClick={onClick}
    className={classes.root}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Grid
      container
      spacing={0}
      wrap="nowrap"
    >
      <Grid
        className={classes.gridItemShrink}
        item
        xs={10}
      >
        <Field
          id="Content"
          name="Content"
          placeholder="Message"
          component={TextField}
          inputRef={(inputRef) => {
            if (inputRef) {
              inputRef.focus();
              inputRef.setSelectionRange(initialValues.Content.length, initialValues.Content.length);
            }
          }}
          validate={[validate.required]}
          errorPlacement="bottom"
          size="sm"
          fullWidth
        />
      </Grid>
      <Grid item>
        <IconButton
          className={classes.iconButton}
          onClick={() => submit()}
          tooltipContent="Save"
        >
          <IconSave className={classes.iconSave} />
        </IconButton>
      </Grid>
      <Grid item>
        <IconButton
          className={classes.iconButton}
          onClick={onCancel}
          tooltipContent="Cancel"
        >
          <IconCrossBold className={classes.iconCrossBold} />
        </IconButton>
      </Grid>
    </Grid>
  </form>
);

NotificationsDialogTemplatesItemEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

NotificationsDialogTemplatesItemEditForm.defaultProps = {
  className: '',
  error: null,
  onCancel: () => {},
};

export default reduxForm({
  form: 'notificationTemplateEditForm',
  onSubmit,
})(withStyles(styles)(NotificationsDialogTemplatesItemEditForm));



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialogTemplatesItemEditForm.js